/* eslint-disable */
import * as z from '@blablacar/common-openapi-codegen/zod'

/**
 * Station Display Auth API
 * Station Display Auth API
 *
 * OpenAPI document version: 1.0.0
 * Contact: team_operated_buses_software@blablacar.com
 *
 * NOTE: This is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * From https://github.com/blablacar/common-openapi | frontend/ob-software/station-display/station-display-auth.yml
 * Codegen fetch "standard" | Codegen version "4.104.0"
 *
 * Do not edit manually.
 */

// Collection formats for array serialization
// @ts-ignore: constant may be unused
const COLLECTION_FORMATS = {
  csv: ',',
  ssv: ' ',
  tsv: '\t',
  pipes: '|',
  multi: ''
} as const

// @ts-ignore: import may be unused
import { WithIgnoredHeaders } from './ignoredHeaders'
// @ts-ignore: import may be unused
import * as Parsers from '../parsers'
// @ts-ignore: import may be unused
import * as Models from '../models';


type LoginByCredentialsRequestParametersWithHeaders = {
  body: Models.LoginByCredentialsRequest.LoginByCredentialsRequest; 
}

export type LoginByCredentialsRequestParameters =
  WithIgnoredHeaders<LoginByCredentialsRequestParametersWithHeaders>

type LogoutRequestParametersWithHeaders = {
  'Authorization': string; 
}

export type LogoutRequestParameters =
  WithIgnoredHeaders<LogoutRequestParametersWithHeaders>

type ResetUserPasswordRequestParametersWithHeaders = {
  body: Models.UserPasswordResetRequest.UserPasswordResetRequest; 
}

export type ResetUserPasswordRequestParameters =
  WithIgnoredHeaders<ResetUserPasswordRequestParametersWithHeaders>

type UpdateUserPasswordRequestParametersWithHeaders = {
  'Authorization': string; 
  body: Models.UserPasswordUpdateRequest.UserPasswordUpdateRequest; 
}

export type UpdateUserPasswordRequestParameters =
  WithIgnoredHeaders<UpdateUserPasswordRequestParametersWithHeaders>

type APIFetchParameters = typeof fetch | {
  fetch: typeof fetch
  endpointUrl?: string
}

export const raw = {
  loginByCredentials(
    fetchParameters: APIFetchParameters,
    requestParameters: LoginByCredentialsRequestParameters
  ) {

    const headerParameters: Record<string, any> = {
      'x-blablacar-openapi-codegen-type': 'typescript',
      'x-blablacar-openapi-codegen-version': '4.104.0',
      'x-blablacar-openapi-codegen-endpoint': 'POST /api/agent/login',
    };

    headerParameters['Content-Type'] = 'application/json';

    const url = 'endpointUrl' in fetchParameters && fetchParameters.endpointUrl ? fetchParameters.endpointUrl : urls.loginByCredentials

    const fetch = 'fetch' in fetchParameters ? fetchParameters.fetch : fetchParameters

    return fetch(url,
      {
        method: 'POST',
        headers: headerParameters,
        body: JSON.stringify(requestParameters.body),
      }
    );
  },
  loginByRefreshToken(
    fetchParameters: APIFetchParameters,
    
  ) {

    const headerParameters: Record<string, any> = {
      'x-blablacar-openapi-codegen-type': 'typescript',
      'x-blablacar-openapi-codegen-version': '4.104.0',
      'x-blablacar-openapi-codegen-endpoint': 'POST /api/agent/login/refresh-token',
    };

    const url = 'endpointUrl' in fetchParameters && fetchParameters.endpointUrl ? fetchParameters.endpointUrl : urls.loginByRefreshToken

    const fetch = 'fetch' in fetchParameters ? fetchParameters.fetch : fetchParameters

    return fetch(url,
      {
        method: 'POST',
        headers: headerParameters,
      }
    );
  },
  logout(
    fetchParameters: APIFetchParameters,
    requestParameters: LogoutRequestParameters
  ) {

    const headerParameters: Record<string, any> = {
      'x-blablacar-openapi-codegen-type': 'typescript',
      'x-blablacar-openapi-codegen-version': '4.104.0',
      'x-blablacar-openapi-codegen-endpoint': 'POST /api/agent/logout',
    };

    if (requestParameters['Authorization'] !== undefined && requestParameters['Authorization'] !== null) {
      headerParameters['Authorization'] = String(requestParameters['Authorization']);
    }

    const url = 'endpointUrl' in fetchParameters && fetchParameters.endpointUrl ? fetchParameters.endpointUrl : urls.logout

    const fetch = 'fetch' in fetchParameters ? fetchParameters.fetch : fetchParameters

    return fetch(url,
      {
        method: 'POST',
        headers: headerParameters,
      }
    );
  },
  resetUserPassword(
    fetchParameters: APIFetchParameters,
    requestParameters: ResetUserPasswordRequestParameters
  ) {

    const headerParameters: Record<string, any> = {
      'x-blablacar-openapi-codegen-type': 'typescript',
      'x-blablacar-openapi-codegen-version': '4.104.0',
      'x-blablacar-openapi-codegen-endpoint': 'POST /api/agent/reset-password',
    };

    headerParameters['Content-Type'] = 'application/json';

    const url = 'endpointUrl' in fetchParameters && fetchParameters.endpointUrl ? fetchParameters.endpointUrl : urls.resetUserPassword

    const fetch = 'fetch' in fetchParameters ? fetchParameters.fetch : fetchParameters

    return fetch(url,
      {
        method: 'POST',
        headers: headerParameters,
        body: JSON.stringify(requestParameters.body),
      }
    );
  },
  updateUserPassword(
    fetchParameters: APIFetchParameters,
    requestParameters: UpdateUserPasswordRequestParameters
  ) {

    const headerParameters: Record<string, any> = {
      'x-blablacar-openapi-codegen-type': 'typescript',
      'x-blablacar-openapi-codegen-version': '4.104.0',
      'x-blablacar-openapi-codegen-endpoint': 'POST /api/agent/update-password',
    };

    headerParameters['Content-Type'] = 'application/json';

    if (requestParameters['Authorization'] !== undefined && requestParameters['Authorization'] !== null) {
      headerParameters['Authorization'] = String(requestParameters['Authorization']);
    }

    const url = 'endpointUrl' in fetchParameters && fetchParameters.endpointUrl ? fetchParameters.endpointUrl : urls.updateUserPassword

    const fetch = 'fetch' in fetchParameters ? fetchParameters.fetch : fetchParameters

    return fetch(url,
      {
        method: 'POST',
        headers: headerParameters,
        body: JSON.stringify(requestParameters.body),
      }
    );
  },
}

export function loginByCredentials(
  fetchParameters: APIFetchParameters,
  requestParameters: LoginByCredentialsRequestParameters
) {
  return async <Folds extends z.Folds<Parsers.LoginByCredentialsResponses>>(folds: z.StrictFolds<Folds, z.Folds<Parsers.LoginByCredentialsResponses>>): Promise<z.InferFoldReturn<Folds>> => {
    const parametersParsingResults = Parsers.POST[`/api/agent/login`].parameters({
      body: requestParameters.body,
    })

    if (parametersParsingResults.success === false) {
      return folds.onError(parametersParsingResults.error)
    }

    const response = await raw.loginByCredentials(fetchParameters, requestParameters)

    return Parsers.POST[`/api/agent/login`].foldOnJsonResponses(response, folds)
  }
}
export function loginByRefreshToken(
  fetchParameters: APIFetchParameters,
  
) {
  return async <Folds extends z.Folds<Parsers.LoginByRefreshTokenResponses>>(folds: z.StrictFolds<Folds, z.Folds<Parsers.LoginByRefreshTokenResponses>>): Promise<z.InferFoldReturn<Folds>> => {

    const response = await raw.loginByRefreshToken(fetchParameters)

    return Parsers.POST[`/api/agent/login/refresh-token`].foldOnJsonResponses(response, folds)
  }
}
export function logout(
  fetchParameters: APIFetchParameters,
  requestParameters: LogoutRequestParameters
) {
  return async <Folds extends z.Folds<Parsers.LogoutResponses>>(folds: z.StrictFolds<Folds, z.Folds<Parsers.LogoutResponses>>): Promise<z.InferFoldReturn<Folds>> => {
    const parametersParsingResults = Parsers.POST[`/api/agent/logout`].parameters({
      'Authorization': requestParameters['Authorization'],
    })

    if (parametersParsingResults.success === false) {
      return folds.onError(parametersParsingResults.error)
    }

    const response = await raw.logout(fetchParameters, requestParameters)

    return Parsers.POST[`/api/agent/logout`].foldOnJsonResponses(response, folds)
  }
}
export function resetUserPassword(
  fetchParameters: APIFetchParameters,
  requestParameters: ResetUserPasswordRequestParameters
) {
  return async <Folds extends z.Folds<Parsers.ResetUserPasswordResponses>>(folds: z.StrictFolds<Folds, z.Folds<Parsers.ResetUserPasswordResponses>>): Promise<z.InferFoldReturn<Folds>> => {
    const parametersParsingResults = Parsers.POST[`/api/agent/reset-password`].parameters({
      body: requestParameters.body,
    })

    if (parametersParsingResults.success === false) {
      return folds.onError(parametersParsingResults.error)
    }

    const response = await raw.resetUserPassword(fetchParameters, requestParameters)

    return Parsers.POST[`/api/agent/reset-password`].foldOnJsonResponses(response, folds)
  }
}
export function updateUserPassword(
  fetchParameters: APIFetchParameters,
  requestParameters: UpdateUserPasswordRequestParameters
) {
  return async <Folds extends z.Folds<Parsers.UpdateUserPasswordResponses>>(folds: z.StrictFolds<Folds, z.Folds<Parsers.UpdateUserPasswordResponses>>): Promise<z.InferFoldReturn<Folds>> => {
    const parametersParsingResults = Parsers.POST[`/api/agent/update-password`].parameters({
      body: requestParameters.body,
      'Authorization': requestParameters['Authorization'],
    })

    if (parametersParsingResults.success === false) {
      return folds.onError(parametersParsingResults.error)
    }

    const response = await raw.updateUserPassword(fetchParameters, requestParameters)

    return Parsers.POST[`/api/agent/update-password`].foldOnJsonResponses(response, folds)
  }
}

export const urls = {
  loginByCredentials: `/api/agent/login`,
  loginByRefreshToken: `/api/agent/login/refresh-token`,
  logout: `/api/agent/logout`,
  resetUserPassword: `/api/agent/reset-password`,
  updateUserPassword: `/api/agent/update-password`,
} as const
